<template>
  <div style="height: 200px; width: 50%;" class="pr-2 pb-2">
    <v-card class="d-flex fill-height">
      <v-card-text style="position: relative;" class="align-self-stretch">
        <!--    -->
        <v-row v-if="loading" style="position: absolute; left: 12px; top:0px; width: 100%; height: 100%;"
               justify="center" align="center">
          <v-progress-circular indeterminate color="accent" size="64"/>
        </v-row>
        <v-row v-else style="position: absolute; left: 12px; top:0px; bottom: 0; right: 12px">
          <v-col :cols="12" class="d-flex flex-column justify-space-between" style="position: relative;">
            <h6 class="body-1 ml-1 mt-0 text-no-wrap text-truncate text-center">
              <v-icon v-if="targetReached" size="large" class="mb-1">mdi-checkbox-outline</v-icon>
              {{ activity.name }}
            </h6>
<!--            <v-icon v-if="targetReached" style="position: absolute; right: 4px; bottom: 4px;">mdi-check-circle-outline</v-icon>-->
            <v-row class="justify-space-around pt-5 mr-0 ml-0 flex-grow-0 flex-shrink-1">
              <v-col class="pa-0 flex-grow-0 flex-shrink-0" style="position: relative;">
                <div class="text-center">
                  <span class="display-2" style="white-space: nowrap;">{{ formatDE(weekValue) }}</span>
                  <span>/</span>
                  <span style="white-space: nowrap;">{{ formatDE(target) }}</span>
                  <span class="ml-2 grey--text body-2 text-no-wrap">(⌀ {{ activityAvg(activity) }})</span>
                </div>
                <div style="position: absolute; right: 4px; top:0; font-size: 20px; margin-top: 0">
                  <v-icon v-if="lastWeekActivitySums" :color="indexTrendColor" size="large">
                    {{indexTrendIcon}}
                  </v-icon>
                </div>
<!--                <div style="position: absolute; right: -16px; bottom:20px; margin-top: 0">-->
<!--                  <span class="ml-0 grey&#45;&#45;text body-2">(⌀ {{ activityAvg(activity) }})</span>-->
<!--                </div>-->
                <div class="caption text-center text-no-wrap">{{ unit }} {{ proZeiteinheit }}</div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <bar-chart class="mt-5" ref="vuechart" :chartdata="chartData" :options="options" :height="80"/>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import BarChart from "@/components/Charts/BarChart";

const {DateTime} = require("luxon");
import {formatDE, round} from "@/reusable/numbers";
import Bereiche from "@/components/Bereiche";
import Kinds from "@/components/Kinds";
import Activity from "@/components/Activity";
import ActivityLibrary from "@/components/ActivityLibrary";
import {Ziele} from "@/components/Ziele";
//import {Targets} from "@/components/Targets";

export default {
  name: "NumValueWeek",
  components: {BarChart},
  props: ['activity', 'date', 'targets', 'activitySums', 'lastWeekActivitySums', 'activityTotals'],
  data() {
    return {
      loading: false,
      datetime: undefined,
      //weekValue: undefined, // <-- computed
      values: [],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              display: false,
            },
            stacked: true,
          }],
          yAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              display: false,
            },
            stacked: true,
          }]
        },
        layout: {
          padding: {
            top: 5,
            right: -10,
            left: -20,
          }
        },
        tooltips: {
          enabled: false
        }
      },
      chartData: {},
      canvas: undefined,
      chart: undefined,
    }
  },
  mounted() {
    this.reload();
    this.chart = this.$refs.vuechart._data._chart;
    this.canvas = this.chart.canvas;
    var self = this;
    //this.$nextTick(() => self.updateChart());
  },
  methods: {
    async reload() {
      this.loading = true;
      this.datetime = DateTime.fromJSDate(new Date(this.date || Date.now())).setLocale("de").startOf("week");
      //var erfolgsmatrix=await this.$backend.get_settings("@erfolgsmatrix" );
      //if (erfolgsmatrix)
      //  this.bereich_weights=Bereiche.getWeights(erfolgsmatrix);
      var iso_date = this.datetime.toISODate().substr(0, 10);
      //var record_id=Activity.makeRecordId(iso_date, this.activity_id);
      var records=[];
      if (this.activity.type===ActivityLibrary.TYPE_SUMME) {
        for (const aid of (this.activity.dependencies || [])) {
          var recs = await this.$backend.get_daily_records(iso_date, aid, 7);
          recs.forEach(x=>records.push(x));
        }
      }
      else {
        records = await this.$backend.get_daily_records(iso_date, this.activity.id, 7);
      }
      console.log({records});
      this.values = records;
      this.loading = false;
    },
    activityAvg(activity) {
      var totals=(this.activityTotals || {}).allTimeTotals || {};
      var Ns=(this.activityTotals || {}).allTimeNs || {};
      var total=totals[activity.id] || 0;
      var n = Ns[activity.id] || 0;
      if (n===0)
        return 0;
      return Math.round(total / n, 0);
    },
    formatDE(val) {
      var decimals=1;
      if (this.activity.unit === "Minuten" || this.activity.unit === "Zeit")
        decimals=0;
      var s= formatDE(val,decimals);
      if (s==="NaN")
        return "0";
      return s;
    },
    getGradient() {
      if (!this.canvas)
        return "#ffdd00";
      // Create a linear gradient
      // The start gradient point is at x=20, y=0
      // The end gradient point is at x=220, y=0
      var ctx = this.canvas.getContext('2d');
      var gradient = ctx.createLinearGradient(0, 90, 0, -10);
      // Add three color stops
      gradient.addColorStop(0.2, '#ffca3700');
      //gradient.addColorStop(.5, 'cyan');
      gradient.addColorStop(1, '#ffca37f0');
      return gradient;
    },
    updateChart() {
      var datetime = this.datetime;
      var labels = [];
      for (var i = 0; i < 7; i++)
        labels.push(datetime.plus({days: i}).weekdayShort.substr(0, 1));
      //console.log({labels, values: this.values})
      this.chartData.labels = labels;
      this.chartData.datasets = this.getDatasets();
      if (this.chart)
        this.chart.update();
    },
    getDatasets() {
      var datasets = [];
      var target = this.dailyTarget;
      var values = this.values.map(x => x.value || 0);
      var rest_values = values.map(x => x >= target ? 0 : target - x); // missed goals
      var ziel_values = [target, target, target, target, target, target, target];
      datasets.push({
        label: 'wert?',
        stack: "all",
        backgroundColor: Bereiche.COLORS_BY_NAME[this.activity.bereich],
        data: values,
      });
      datasets.push({
        label: 'verfehltes Ziel',
        stack: "all",
        backgroundColor: '#ebebeb',
        data: rest_values,
      });
      // datasets.push({
      //   label: 'Ziel',
      //   type: 'line',
      //   //backgroundColor: 'black',
      //   borderColor: 'black',
      //   data: ziel_values,
      //   lineTension: 0,
      //   fill: false,
      //   showLine: true,
      //   borderWidth: 1,
      //   pointRadius: 0,
      //   pointBorderWidth: 0,
      //   pointHitRadius: 0,
      //   pointHoverRadius: 0,
      //   borderDash: [10, 5],
      //   spanGaps: false,
      // });
      return datasets;
    },
    calcWeekSum() {
      //if (this.activity.freq == ActivityLibrary.FREQ_WEEKLY)
      // var sum=Math.round(this.values.map(x => Number(x.value) || 0).reduce((x, y) => x + y, 0));
      // this.weekValue=sum;
      // return sum;
      //else
      //  return round(this.values.map(x=>x.value||0).reduce((x,y)=>x+y, 0) / 7.0, 1);
    },
    getTextStyle(bereich) {
      return {'color': Bereiche.COLORS_BY_NAME[bereich]};
    }
  },
  computed: {
    weekValue() {
      if (this.activitySums)
        return this.activitySums[this.activity.id] || 0;
      return 0;
    },
    lastWeekValue() {
      if (this.lastWeekActivitySums)
        return this.lastWeekActivitySums[this.activity.id] || 0;
      return 0;
    },
    bereiche() {
      return Bereiche.NAMES;
    },
    target() {
      var freq=this.activity.freq;
      if (freq === ActivityLibrary.FREQ_DAILY || freq === ActivityLibrary.FREQ_WEEKLY)
        return this.weekTarget;
      return this.otherTarget;
    },
    otherTarget() {
      var targets=this.targetValues;
      var actiTarget = this.activity.target;
      var aid=this.activity.id;
      var t=(targets && targets.hasOwnProperty(aid)) ? targets[aid] || actiTarget : actiTarget;
      return t;
    },
    weekTarget() {
      var t=this.otherTarget;
      if (this.activity.freq === ActivityLibrary.FREQ_WEEKLY)
        return t;
      else if (this.activity.type === ActivityLibrary.TYPE_BOOL)
        return 7;
      else
        return t * 7;
    },
    dailyTarget() {
      var t=this.otherTarget;
      if (this.activity.freq === ActivityLibrary.FREQ_WEEKLY)
        return t / 7.0;
      else if (this.activity.type === ActivityLibrary.TYPE_BOOL)
        return 1;
      else
        return t;
    },
    unit() {
      if (this.activity.type === ActivityLibrary.TYPE_BOOL)
        return "mal";
      return this.activity.unit;
    },
    proZeiteinheit() {
      var freq=this.activity.freq;
      if (freq === ActivityLibrary.FREQ_DAILY || freq === ActivityLibrary.FREQ_WEEKLY)
        return "pro Woche";
      return freq;
    },
    targetValues() {
      if (!this.targets)
        return undefined;
      return new Ziele(this.targets).getTargets(this.date);
    },
    targetReached() {
      return (this.weekTarget <= this.weekValue);
    },
    indexTrendIcon() {
      if (!this.lastWeekActivitySums)
        return "";
      var last=this.lastWeekValue;
      if (last < this.weekValue)
        return 'mdi-arrow-up-circle';
      if (last > this.weekValue)
        return 'mdi-arrow-down-circle';
      return 'mdi-checkbox-marked-circle';
    },
    indexTrendColor() {
      if (!this.lastWeekActivitySums)
        return "";
      var last=this.lastWeekValue;
      if (last < this.weekValue)
        return 'green lighten-1';
      if (last > this.weekValue)
        return 'red lighten-1';
      return 'green lighten-1';
    },
  },
  watch: {
    date() {
      this.reload();
    },
    values: {
      //immediate:true,
      handler() {
        this.updateChart();
      }
    }
  }
}
</script>

<style scoped>

</style>